import apiManager from "./apiManager";

import { apiStaticDataUrls } from "config/endPoints";
import {
  initializeTerms,
  initializeChannel,
  initializeLanguages,
} from "store/staticDataActions";
import { accountInitialize } from "store/accountActions";

const normalize = (code) => (code || "").split("-")[0].toLowerCase();
const urlLangSeg = () => window.location.pathname.split("/")[1]?.toLowerCase();

const staticDataManager = (store) => {
  const { dispatch } = store;
  termsLoader(dispatch);
  channelLoader(dispatch);
  languagesLoader(store);
};

export const termsLoader = (dispatch) => {
  apiManager
    .get(apiStaticDataUrls.API_GET_TERMS)
    .then((response) => {
      // console.log("staticDataManager-response: ", response);
      if (response.data.isSuccess && response.data.data) {
        dispatch(initializeTerms({ terms: response.data.data }));
      }
    })
    .catch(function (error) {
      console.log("staticDataManager-error: ", error);
    });
};

const channelLoader = (dispatch) => {
  apiManager
    .get(
      `${apiStaticDataUrls.API_GET_CHANNEL}/${process.env.REACT_APP_CHANNEL_CODE}`
    )
    .then((response) => {
      // console.log("staticDataManager-channelLoader-response: ", response);
      if (response.data.isSuccess && response.data.data) {
        dispatch(initializeChannel({ channel: response.data.data }));
      }
    })
    .catch(function (error) {
      console.log("staticDataManager-error: ", error);
    });
};

const languagesLoader = (store) => {
  const { dispatch, getState } = store;

  apiManager
    .get(apiStaticDataUrls.API_GET_LANGUAGES)
    .then((response) => {
      if (response.data.isSuccess && response.data.data) {
        const langs = response.data.data;
        dispatch(initializeLanguages({ languages: langs }));
        initializeAccount(langs, dispatch, getState);
      }
    })
    .catch((error) =>
      console.log("staticDataManager-languagesLoader-error: ", error)
    );
};

const initializeAccount = (languages, dispatch, getState) => {
  const state = getState();
  const current = state.account?.language;
  const seg = urlLangSeg();

  const langFromUrl = seg
    ? languages.find((l) => normalize(l.code) === seg)
    : null;

  let defaultLang = languages.find((l) => l.isDefault) || languages[0];

  const chosen = langFromUrl || current || defaultLang;

  if (!chosen) return;
  if (state.account?.language?.code === chosen.code) return;

  dispatch(
    accountInitialize({
      language: chosen,
      settings: { popUpTermDismissed: false },
    })
  );
};

export default staticDataManager;

const loadTerms = (selector, term) => {
  const { language } = selector((state) => state.account);
  const { terms } = selector((state) => state.staticData);
  let entity = terms
    ? terms.find((le) => {
        return le.keyName === term;
      })
    : null;
  let localization = extractLocalizedTerms(entity, language);
  if (localization) return localization;
  return term;
};

const extractLocalizedTerms = (entity, language) => {
  if (entity && entity.localizedTerms) {
    let term = language
      ? entity.localizedTerms.find((lt) => {
          return lt.languageId === language.languageId;
        })
      : entity.localizedTerms[0];
    if (term) return term.termValue;
  }
};

export const staticData = { loadTerms };
